import { createClient } from '@supabase/supabase-js';

// Environment detection
const getEnvironment = () => {
  const hostname = window.location.hostname;
  
  if (hostname.includes('staging-book.cybermed.ai') || hostname.includes('staging') || hostname.includes('preview')) {
    return 'staging';
  } else if (hostname === 'book.cybermed.ai') {
    return 'production';
  } else if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  } else {
    return 'production'; // fallback to production for unknown domains
  }
};

// Get Supabase configuration based on environment
const getSupabaseConfig = () => {
  const env = getEnvironment();
  
  switch (env) {
    case 'staging':
      return {
        url: import.meta.env.VITE_STAGING_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL,
        key: import.meta.env.VITE_STAGING_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY,
      };
    case 'development':
      return {
        url: import.meta.env.VITE_DEV_SUPABASE_URL || import.meta.env.VITE_SUPABASE_URL,
        key: import.meta.env.VITE_DEV_SUPABASE_ANON_KEY || import.meta.env.VITE_SUPABASE_ANON_KEY,
      };
    default: // production
      return {
        url: import.meta.env.VITE_SUPABASE_URL,
        key: import.meta.env.VITE_SUPABASE_ANON_KEY,
      };
  }
};

const { url: supabaseUrl, key: supabaseAnonKey } = getSupabaseConfig();

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

// Log environment for debugging (only in development)
if (getEnvironment() === 'development') {
  console.log('🔧 Supabase Environment:', getEnvironment());
  console.log('🔧 Supabase URL:', supabaseUrl);
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Use localStorage for better persistence across page refreshes
    storage: window.localStorage,
    storageKey: 'sb-auth-token',
    // Improve session recovery timing
    flowType: 'pkce',
    debug: false
  },
  // Add global configuration for better reliability
  global: {
    headers: {
      'X-Client-Info': 'medical-device-cybersecurity-book@1.0.15'
    }
  }
});

// Database types
export interface UserProfile {
  id: string;
  first_name: string;
  last_name: string;
  is_admin: boolean;
  activecampaign_contact_id?: string;
  reading_progress: Record<string, any>;
  last_active: string;
  created_at: string;
  updated_at: string;
}

export interface Comment {
  id: string;
  user_id: string;
  block_id: string;
  content: string;
  created_at: string;
  updated_at: string;
  user_profile?: UserProfile;
}
